import { render, staticRenderFns } from "./TestInside.vue?vue&type=template&id=a8fe66b6&"
import script from "./TestInside.vue?vue&type=script&lang=js&"
export * from "./TestInside.vue?vue&type=script&lang=js&"
import style0 from "./TestInside.vue?vue&type=style&index=0&id=a8fe66b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports